module.exports = __webpack_public_path__ + "img/search.87ebe8ac.png";